// FiguTour v2 (Phase 16 + Phase 19b) — centralised step definitions.
// KEEP i18n keys here. Do NOT scatter user-visible strings across
// components. Order defines the tour flow.
//
// Special target sentinels:
//   target: null        → welcome step, no DOM target; ball goes center-bottom
//   target: "roboball"  → spotlight the FAB itself; ball stays put
export const FIGUTOUR_STEPS = [
  {
    id: "welcome",
    target: null,
    bubbleKey: "figutour.step1_welcome",
  },
  {
    id: "inventory",
    target: "#inventory-grid",
    bubbleKey: "figutour.step2_inventory",
  },
  {
    id: "radar",
    target: "#radar-tab",
    bubbleKey: "figutour.step3_radar",
  },
  {
    id: "rewards",
    target: "#share-earn-item",
    bubbleKey: "figutour.step4_rewards",
  },
  {
    id: "launch",
    target: "roboball",
    bubbleKey: "figutour.step5_launch",
  },
  // Phase 19b — 6th step. Spotlights the wallet button in AppShell.
  {
    id: "wallet",
    target: '[data-testid="app-wallet-button"]',
    bubbleKey: "figutour.step6_wallet",
  },
];
